export default __webpack_public_path__ + "static/media/40313.9db1fd25.jpg";